import React from "react";
import ManageCohorts from "./manageCohorts";

export default function TrackStudents() {
  return <ManageCohorts />;
}